"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutsideClick = exports.useIMEControl = void 0;
var react_1 = require("react");
var useIMEControl = function () {
    var _a = __read((0, react_1.useState)(false), 2), isComposing = _a[0], setComposing = _a[1];
    var onCompositionStart = function () { return setComposing(true); };
    var onCompositionEnd = function () { return setComposing(false); };
    return [isComposing, { onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd }];
};
exports.useIMEControl = useIMEControl;
var noop = function (e) { };
var currentHandler = noop;
var useOutsideClick = function (insideRef, onClick) {
    (0, react_1.useEffect)(function () {
        var insideElement = insideRef.current;
        if (!insideElement) {
            return;
        }
        // fix memory leak
        if (currentHandler !== noop) {
            document.removeEventListener("click", currentHandler);
        }
        var handleClick = function (e) {
            if (e.target && !insideElement.contains(e.target)) {
                onClick();
            }
        };
        currentHandler = handleClick;
        document.addEventListener("click", handleClick);
        return function () { return document.removeEventListener("click", handleClick); };
    }, [insideRef, onClick]);
};
exports.useOutsideClick = useOutsideClick;
